import { Link } from 'react-router-dom';

import { BsBuilding, BsChevronRight, BsLightning, BsMailbox, BsMap, BsPeople } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';

const QUICK_ACTIONS = [
	{
		id: 'lead-search',
		icon: BsBuilding,
		title: 'Lead-Suche',
		description: 'Neue Unternehmen finden',
		link: '/leads',
	},
	{ id: 'map-search', icon: BsMap, title: 'Kartensuche', description: 'Standortbasierte Suche', link: '/map-search' },
	{
		id: 'email-campaigns',
		icon: BsMailbox,
		title: 'E-Mail Kampagnen',
		description: 'Kampagne erstellen',
		link: '/email-campaigns',
	},
	{
		id: 'contact-lists',
		icon: BsPeople,
		title: 'Kontaktlisten',
		description: 'Kontakte verwalten',
		link: '/contact-lists',
	},
];

const QuickActionsCard = () => (
	<SectionCard title="Schnellzugriff" icon={BsLightning} bodyClassName="p-2">
		<ul>
			{QUICK_ACTIONS.map(({ id, icon: Icon, title, description, link }) => (
				<li key={id}>
					<Link
						to={link}
						className="group flex items-center gap-3 rounded-control p-2 hover:bg-bgBase-300 transition-colors"
					>
						<span className="h-9 w-9 rounded-control bg-primary-100 text-primary-600 flex items-center justify-center flex-shrink-0">
							<Icon className="w-4 h-4" />
						</span>
						<span className="flex-1 min-w-0">
							<span className="block text-sm font-semibold text-text">{title}</span>
							<span className="block text-xs text-bgBase-800 truncate">{description}</span>
						</span>
						<BsChevronRight className="w-3 h-3 text-bgBase-700 group-hover:text-primary-500 transition-colors" />
					</Link>
				</li>
			))}
		</ul>
	</SectionCard>
);

export default QuickActionsCard;
